import { render } from "./WritingZoneListEntry.vue?vue&type=template&id=0c36d0f6&scoped=true"
import script from "./WritingZoneListEntry.vue?vue&type=script&lang=js"
export * from "./WritingZoneListEntry.vue?vue&type=script&lang=js"

import "./WritingZoneListEntry.vue?vue&type=style&index=0&id=0c36d0f6&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c36d0f6"]])

export default __exports__